module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor"
    }
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab, id) {
    return _c('li', {
      key: id,
      class: {
        'is-active': _vm.isCurrentTab(tab)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(_vm.tokens[tab.name.toLowerCase()]))])])
  }))]), _c('div', {
    staticClass: "field expand"
  }, [_c('task-editor-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.text),
      expression: "currentTab === tabs.text"
    }],
    attrs: {
      "task": _vm.ref,
      "intros": _vm.intros,
      "is-name-editable": _vm.isTaskNameEditable,
      "is-cloning": _vm.isCloningTask
    },
    on: {
      "input": _vm.setTextInput
    }
  }), _c('task-editor-feedback', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.feedback),
      expression: "currentTab === tabs.feedback"
    }],
    attrs: {
      "task": _vm.ref
    },
    on: {
      "input": _vm.setFeedbackInput
    }
  }), _c('task-editor-images', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.images),
      expression: "currentTab === tabs.images"
    }],
    attrs: {
      "task": _vm.ref,
      "current-text": _vm.text
    },
    on: {
      "input": _vm.setImagesInput,
      "editing": function($event) {
        _vm.onImageEditing($event)
      }
    }
  }), _c('task-editor-questionnaire', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.questionnaire),
      expression: "currentTab === tabs.questionnaire"
    }],
    attrs: {
      "task": _vm.ref
    },
    on: {
      "input": _vm.setQuestionnaireInput
    }
  })], 1), _c('p', {
    staticClass: "control bottom-panel"
  }, [_c('span', {
    staticClass: "is-inline-block"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.action))]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.feedback),
      expression: "currentTab === tabs.feedback"
    }],
    staticClass: "button stacked",
    on: {
      "click": _vm.setDefaultFeedback
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_set_default']))]), _c('span', {
    staticClass: "is-inline-block stacked"
  }, [_c('bulma-checkbox', {
    staticClass: "is-inline-block",
    attrs: {
      "label": _vm.tokens['lbl_use_timeout'],
      "disabled": false
    },
    model: {
      value: (_vm.useTimeout),
      callback: function($$v) {
        _vm.useTimeout = $$v
      },
      expression: "useTimeout"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.timeout),
      expression: "timeout",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input is-inline-block timeout",
    attrs: {
      "type": "number",
      "step": "1",
      "disabled": !_vm.useTimeout,
      "min": "1",
      "max": "1000"
    },
    domProps: {
      "value": (_vm.timeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timeout = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['lbl_minute']))])], 1), _c('span', {
    staticClass: "is-inline-block stacked"
  }, [_c('bulma-checkbox', {
    staticClass: "is-inline-block",
    attrs: {
      "label": _vm.tokens['lbl_record_audio']
    },
    model: {
      value: (_vm.recordAudio),
      callback: function($$v) {
        _vm.recordAudio = $$v
      },
      expression: "recordAudio"
    }
  })], 1)]), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canPreview
    },
    on: {
      "click": _vm.preview
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_preview']))])]), _c('div', {
    ref: "fullscreen",
    staticClass: "fullscreen"
  }, [(_vm.inPreview) ? _c('task-preview', {
    attrs: {
      "task": _vm.getCurrentTask()
    },
    on: {
      "close": _vm.closePreview
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a42f22a6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TaskEditor.vue
// module id = 445
// module chunks = 0